<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" />

    <b-card>
      <b-row>
        <b-col xl="8" lg="8" md="8" sm="12">
          <h4 v-if="url == null">Adicionar banner</h4>
          <h4 v-else>Editar banner</h4>
        </b-col>
        <b-col xl="4" lg="4" md="4" sm="12">
          <b-button
            variant="success"
            class="ml-3 float-right"
            :disabled="!haveImage"
            @click="adicionar"
          >{{ url === null ? 'Adicionar' : 'Editar'}}</b-button>
          <b-button variant="danger" class="float-right" @click="goBack">Voltar</b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-card class="mt-3">
      <b-row>
        <b-col xl="6" lg="6" md="12" sm="12">
          <b-input-group prepend="Opções">
            <b-form-select v-model="selectedOption" :options="options"></b-form-select>
          </b-input-group>
        </b-col>
        <b-col xl="6" lg="6" md="12" sm="12">
          <b-input-group prepend="Promoções">
            <b-form-select
              v-model="selectedPromotion"
              :options="promotions"
              :disabled="!(selectedOption == 2)"
            ></b-form-select>
          </b-input-group>
        </b-col>
        <b-col cols="12" class="mt-3">
          <b-input-group prepend="Link">
            <b-form-input v-model="link" :disabled="!(selectedOption == 5)"></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
    </b-card>
    <b-card v-if="url != null" header="Imagem antiga" class="mt-3">
      <img v-bind:src="url" alt="Imagem do Banner" class="banner-img" />
    </b-card>
    <b-card header="Imagem nova" class="mt-3">
      <picture-input
        ref="pictureInput"
        :zIndex="10"
        width="800"
        height="350"
        margin="16"
        accept="image/jpeg, image/png"
        size="10"
        button-class="btn"
        :custom-strings="{
          upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
          drag: 'Arraste uma imagem <br> (ou clique aqui)',
          change: 'Mudar foto'
        }"
        @change="onChange"
      />
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import * as config from "@/config.json";
import PictureInput from "vue-picture-input";
import Loading from "vue-loading-overlay";


export default {
  components: { PictureInput, Loading },
  data: _ => {
    return {
      isLoading: false,
      link: null,
      url: null,
      haveImage: false,
      selectedOption: null,
      selectedPromotion: null,
      promotions: [],
      imagem: null,
      id: null,
      options: [
        {
          value: null,
          text: "Comum"
        },
        {
          value: 1,
          text: "Jornalzinho"
        },
        {
          value: 2,
          text: "Promoção"
        },
        {
          value: 3,
          text: "Sorteios"
        },
        {
          value: 4,
          text: "Cupom"
        },
        {
          value: 5,
          text: "Link"
        }
      ]
    };
  },
  async beforeMount() {
    this.isLoading = true;
    await this.getIdPromocoes();

    var editar = Boolean(localStorage.getItem("editar_banner"));
    if (editar) {
      this.haveImage = true;

      const urlPattern = /((ht|f)tp(s)?:\/\/)?(w{0,3}\.)?[a-zA-Z0-9_\-\.\:\#\/\~\}]+(\.[a-zA-Z]{1,4})(\/[a-zA-Z0-9_\-\.\:\#\/\~\}]*)?/g;

      this.id = localStorage.getItem("id_banner");
      this.url = localStorage.getItem("url_banner");
      var redirect = localStorage.getItem("redirect_banner");
      if (redirect == "jornalzinho") {
        this.selectedOption = 1;
      } else if (urlPattern.test(redirect)) {
        this.selectedOption = 5;
        this.link = redirect;
      } else {
        redirect = parseInt(redirect);
        if (redirect < 0) {
          if (redirect == -1) {
            this.selectedOption = 3;
          } else if (redirect == -2) {
            this.selectedOption = 4;
          } else {
            this.selectedOption = null;
          }
        } else {
          this.selectedOption = 2;
          this.selectedPromotion = redirect;
        }
      }
    }

    this.isLoading = false;
  },
  methods: {
    retornaRedirect(selecionado) {
      switch (selecionado) {
        case null:
          return -3;
          break;
        case 1:
          return "jornalzinho";
          break;
        case 2:
          return this.selectedPromotion;
          break;
        case 3:
          return -1;
          break;
        case 4:
          return -2;
          break;
        case 5:
          return this.link;
          break;
      }
    },
    validarCampos() {
      if (this.selectedOption == 2) {
        if (
          this.selectedPromotion == null ||
          this.selectedPromotion == undefined
        )
          return false;
      } else if (this.selectedOption == 5) {
        if (this.link == null || this.link == "") return false;
      }

      return true;
    },
    async adicionar() {
      this.isLoading = true;
      if (this.validarCampos()) {
        if (this.url == null) {
          await axios
            .put(
              `${config.default.servidor}/gerencial/banner`,
              {
                imagem: this.imagem,
                redirecionar: this.retornaRedirect(this.selectedOption),
                empresaid: localStorage.getItem("enterprise_id")
              },
              {
                headers: {
                  Authorization: "Basic c2E6QURNQUNDRVNZUw=="
                }
              }
            )
            .then(response => {
              if (response.status == 200) {
                this.$router.go(-1);
                let toast = this.$toasted.show(
                  "Banner adicionado com sucesso!",
                  {
                    theme: "toasted-primary",
                    position: "bottom-center",
                    duration: 5000,
                    icon: "check",
                    iconPack: "fontawesome"
                  }
                );
              } else {
                const options = { title: "Algo deu errado...", size: "sm" };
                this.$dialogs.alert(
                  "Não conseguimos adicionar seu banner.",
                  options
                );
              }
            })
            .catch(e => {
              const options = { title: "Algo deu errado...", size: "sm" };
              this.$dialogs.alert(`Aconteceu um erro: ${e}.`, options);
            });
        } else {
          console.info({
            id: this.id,
            imagem: this.imagem,
            redirect: this.retornaRedirect(this.selectedOption)
          });
          await axios
            .post(
              `${config.default.servidor}/gerencial/banner/img`,
              {
                empresaid: localStorage.getItem("enterprise_id"),
                bannerid: this.id,
                imagem: this.imagem,
                redirect: this.retornaRedirect(this.selectedOption)
              },
              {
                headers: {
                  Authorization: "Basic c2E6QURNQUNDRVNZUw=="
                }
              }
            )
            .then(response => {
              if (response.status == 200) {
                this.$router.go(-1);
                let toast = this.$toasted.show("Banner editado com sucesso!", {
                  theme: "toasted-primary",
                  position: "bottom-center",
                  duration: 5000,
                  icon: "check",
                  iconPack: "fontawesome"
                });
              } else {
                const options = { title: "Algo deu errado...", size: "sm" };
                this.$dialogs.alert(
                  "Não conseguimos editar seu banner.",
                  options
                );
              }
            })
            .catch(e => {
              const options = { title: "Algo deu errado...", size: "sm" };
              this.$dialogs.alert(`Aconteceu um erro: ${e}.`, options);
            });
        }
      } else {
        const options = { title: "Algo deu errado...", size: "sm" };
        this.$dialogs.alert(
          "Preencha todos os campos antes de continuar.",
          options
        );
      }
      this.isLoading = false;
    },
    goBack() {
      this.$router.go(-1);
    },
    onChange(image) {
      if (image) {
        this.haveImage = true;
        this.imagem = image;
      }
    },
    async getIdPromocoes() {
      await axios
        .get(
          `${
            config.default.servidor
          }/gerencial/promocoes/id/${localStorage.getItem("enterprise_id")}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.status == 200) {
            this.promotions = response.data.data;
            this.selectedPromotion =
              response.data.data.length > 0
                ? response.data.data[0].value
                : null;
          }
        });
    }
  }
};
</script>